import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import {
  DataBlocks,
  Checkbox,
  I18n,
  Button,
  Link,
  ErrorBlock,
} from 'components';

import { getMessage } from 'components/I18n';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const getDefaultState = (props) => ({
  actions: props.actions,
  isActionsDirty: false,
});

class NotifiableActions extends PureComponent {
  constructor(props) {
    super(props);

    this.state = getDefaultState(this.props);
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.actions !== this.props.actions) {
      this.setState(getDefaultState(props));
    }
  }

  toggleAction(toggledAction) {
    this.setState((prevState) => ({
      isActionsDirty: true,
      actions: prevState.actions
        .map((action) => (action === toggledAction ? {
          ...action,
          enabled: !action.enabled,
        } : action)),
    }));
  }

  render() {
    const {
      saveActions,
      isActionsSaving,
      error,
      refreshAction,
    } = this.props;

    const {
      actions,
      isActionsDirty,
    } = this.state;

    if (error) {
      return (
        <ErrorBlock
          title={<I18n path="settings.notifications.notifiableActionsTitle" />}
          refreshAction={refreshAction}
        />
      );
    }

    return (
      <DataBlocks.Block
        title={<I18n path="settings.notifications.notifiableActionsTitle" />}
        isLoading={!actions}
      >
        {actions && actions.map((action) => {
          const path = `settings.notifications.actions.${action.actionType}`;

          return getMessage(path) ? (
            <Checkbox
              key={action.actionType}
              className={cx('checkbox')}
              name={action.actionType}
              checked={action.enabled}
              disabled={isActionsSaving}
              handleChange={() => this.toggleAction(action)}
            >
              {action.name || (
                <I18n path={`settings.notifications.actions.${action.actionType}`} />
              )}
            </Checkbox>
          ) : null;
        })}
        <div className={cx('actions')}>
          <Button
            disabled={!isActionsDirty}
            isLoading={isActionsSaving}
            onClick={() => saveActions(actions)}
          >
            <I18n path="common.save" />
          </Button>
          {!isActionsSaving && isActionsDirty
            && (
            <>
              <I18n
                className={cx('actionsDivider')}
                path="common.or"
              />
              <Link
                className={cx('revertChangesLink')}
                onClick={() => this.setState(getDefaultState(this.props))}
              >
                <I18n path="common.revertChanges" />
              </Link>
            </>
            )}
        </div>
      </DataBlocks.Block>
    );
  }
}

NotifiableActions.propTypes = {
  error: PropTypes.string,
  refreshAction: PropTypes.func,
  actions: PropTypes.array,
  saveActions: PropTypes.func,
  isActionsSaving: PropTypes.bool,
};

export default NotifiableActions;
